<template>
    <div class="search-range">
        <b-form-checkbox
            class="search-range__checkbox"
            :checked="isChecked"
            @change="handleCheckChanged"
        >
            {{ label }}
        </b-form-checkbox>

        <template v-if="isChecked">
            <div class="search-range__slider px-2 pt-2">
                <vue-slider
                    :value="transformedValue"
                    :min="min"
                    :max="max"
                    :duration="0"
                    :interval="1"
                    tooltip="always"
                    lazy
                    silent
                    tooltip-placement="bottom"
                    :tooltip-formatter="tooltipFormatter"
                    @change="handleChanged"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component';
    import { BFormCheckbox } from 'bootstrap-vue';

    export default {
        components: {
            BFormCheckbox,
            VueSlider,
        },
        props: {
            value: Object,
            label: String,
            min: Number,
            max: Number,
            name: String,
            unit: String,
        },
        computed: {
            isChecked() {
                return !!this.value;
            },
            transformedValue() {
                return this.value
                    ? [this.value.min, this.value.max]
                    : [this.min, this.max];
            },
            collapseId() {
                return `range-${this.name}`;
            },
        },
        methods: {
            tooltipFormatter(value) {
                return this.unit ? `${value} ${this.unit}` : value;
            },
            handleCheckChanged(active) {
                this.$emit('input', active ? {
                    min: this.min,
                    max: this.max,
                } : null);
            },
            handleChanged(value) {
                const [min, max] = value;
                if(this.value && this.value.min === min && this.value.max === max) {
                    return;
                }
                this.$emit('input', { min, max });
            },
        },
    }
</script>